<template>
  <router-view></router-view>
</template>
 
<script>
export default {
  name: 'LayoutMain',
  data() { return { }; }
};
</script>



// WEBPACK FOOTER //
// src/components/App.vue